import React from "react";

import { SimpleCard } from "@gull";
import FilesExport from "app/Components/CommanComponents/FilesExport";

import EchartPieChart from "../Chart/Echarts/EchartPieChart";
import EchartFunnelChart from "../Chart/Echarts/EchartFunnelChart";
import EchartMultipleBarChart from "../Chart/Echarts/EchartMultipleBarChart";
import BasicBarChart from "../Chart/Echarts/BasicBarChart";
import StackBarChart from "../Chart/Echarts/StackBarChart";
import BodyPartComponent from "../BodyPartComponent/BodyPartComponent";
import BasicBarChartWithLabel from "../Chart/Echarts/BasicBarChartWithLabel";
import BasicBarChartWithLabelAndCustomToolTip from "../Chart/Echarts/BasicBarChartWithLabelAndCustomToolTip";
import BasicBarChartWithCustomToolTip from "../Chart/Echarts/BasicBarChartWithCustomTooltip";
import ZoomScreen from "../ZoomScreen/ZoomScreen";
import { MANAGE_PIE_CHART_WITH_LARGE_DATA } from "../PieChartWithModal/PieChartWithModal";

export const PieChartCard = React.memo(function PieChartCard({
  isClick,
  dataFromChartCard,
  childfun,
  seriesData,
  title,
  id,
  customLabelFalse,
  isCustomLegend,
  isMobile = 0,
  pieChartColour,
  scrollLegend,
  setZoomActive,
  zoomActive,
  hideZoom = false,
}) {
  let seriesList = [];
  if (Array.isArray(seriesData)) {
    seriesList = seriesData.filter((d) => d.value != 0 && d.value != null);
  }
  const getPieElementData = (e) =>
    isClick && dataFromChartCard ? dataFromChartCard(e) : null;

  const managePieOptions = MANAGE_PIE_CHART_WITH_LARGE_DATA(seriesList?.length);

  let extraLegendOptions =
    zoomActive && managePieOptions
      ? {
          orient: "vertical",
          right: managePieOptions?.right,
          textStyle: { fontSize: 12 },
          itemGap: 5,
          itemWidth: 10,
          itemHeight: 10,
        }
      : { orient: "horizontal", bottom: zoomActive ? 30 : "bottom" };

  return (
    <SimpleCard className="drilling_dash_block overflow-inherit">
      {
        <div className="simple-card-title d-flex justify-content-between">
          <h3 className="text-capitalize mb-1">{title}</h3>
          <div className="selectDateHours mr-3">
            {isMobile != 1 && (
              <>
                {!hideZoom && (scrollLegend || zoomActive) && (
                  <ZoomScreen setZoomActive={setZoomActive} id={id} />
                )}
                <FilesExport id={`#${id}`} />
              </>
            )}
          </div>
        </div>
      }
      <EchartPieChart
        pieChartColour={pieChartColour}
        seriesData={seriesList}
        tooltip={{
          trigger: "item",
          axisPointer: {
            type: "shadow",
          },

          formatter: function (param, index) {
            let text =
              param.name +
              "<br />" +
              param.marker +
              param.seriesName +
              ": " +
              param.data.value +
              " (" +
              param.percent +
              "%)";
            return text;
          },
        }}
        customLabel={
          customLabelFalse
            ? {
                show: true,
                type: "scroll",
                formatter: "{c}",
              }
            : true
        }
        customLegend={
          isCustomLegend
            ? {
                type: isMobile === 1 ? "scroll" : scrollLegend ? "scroll" : "plain",
                // orient: "horizontal",
                // bottom: "bottom",

                ...extraLegendOptions,
              }
            : { left: "left" }
        }
        childfun={getPieElementData}
        isClickAble={isClick}
        zoomActive={zoomActive}
        seriesOptions={managePieOptions ? managePieOptions?.seriesOptions : false}
      ></EchartPieChart>
    </SimpleCard>
  );
});

export function SimplePieChartCard({ seriesData, title, id, zero }) {
  let seriesList = [];
  if (Array.isArray(seriesData)) {
    seriesList = seriesData;
    if (!zero) {
      seriesList = seriesData.filter((d) => d.value != 0 && d.value != null);
    }
  }

  return (
    <SimpleCard className="drilling_dash_block">
      <div className="simple-card-title d-flex justify-content-between">
        <h3 className="text-capitalize mb-1">{title}</h3>
        <div className="selectDateHours mr-3">
          <FilesExport id={`#${id}`} />
        </div>
      </div>
      <EchartPieChart
        seriesData={seriesList}
        tooltip={{
          trigger: "item",
          axisPointer: {
            type: "shadow",
          },

          formatter: function (param, index) {
            let text =
              param.name +
              "<br />" +
              param.marker +
              param.seriesName +
              ": " +
              param.data.value +
              "%";
            return text;
          },
        }}
        customLabel={{
          emphasis: {
            show: true,
            textStyle: {
              fontSize: "13",
              fontWeight: "bold",
            },
            formatter: "{b} \n{c} %",
          },
        }}
      ></EchartPieChart>
    </SimpleCard>
  );
}

export function BarChartCard(props) {
  return (
    <SimpleCard className="drilling_dash_block">
      <div className="simple-card-title d-flex justify-content-between">
        <h3 className="text-capitalize mb-1">{props.title}</h3>
        <div className="selectDateHours mr-3">
          {props.id && <FilesExport id={`#${props.id}`} />}
        </div>
      </div>

      <BasicBarChart
        yAxisName={props.yAxisName}
        xAxisName={props.xAxisName}
        categoryData={props.categoryData ? props.categoryData : []}
        series={props.seriesData ? props.seriesData : []}
        toolbox={{
          show: true,
          showTitle: true,
          feature: {
            // dataView: {
            //   show: true,
            //   readOnly: false,
            //   title: 'Data View',
            //   lang: ['Data View', 'Close', 'Refresh'],
            // },
            magicType: {
              type: ["line", "bar"],
              title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
              },
            },
          },
        }}
        legend={{
          bottom: "0%",
          type: "scroll",
          orient: "horizontal",
          horizontalAlign: "center",
          itemGap: 15,
          to: 100,
          //left: '0%'
        }}
        tooltip={{
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56",
              formatter: function (params) {
                return params.axisDimension === "y"
                  ? parseInt(params.value)
                  : params.value;
              },
            },
          },
        }}
      />
    </SimpleCard>
  );
}
export function BasicBarChartCardWithCustomToolTip(props) {
  return (
    <SimpleCard className="drilling_dash_block">
      {
        <div className="simple-card-title d-flex justify-content-between">
          <h3 className="text-capitalize mb-1">{props.title}</h3>
          <div className="selectDateHours mr-3">
            {props.isMobile != 1 && <FilesExport id={`#${props.id}`} />}
          </div>
        </div>
      }

      <BasicBarChartWithCustomToolTip
        customToolTip={props.customToolTip}
        legendFlag={props.legendFlag}
        yAxisName={props.yAxisName}
        xAxisName={props.xAxisName}
        category={props.category ? props.category : []}
        seriesData={props.seriesData}
      />
    </SimpleCard>
  );
}
export function StackBarChartCard(props) {
  return (
    <SimpleCard className="drilling_dash_block">
      {
        <div className="simple-card-title d-flex justify-content-between">
          <h3 className="text-capitalize mb-1">{props.title}</h3>
          <div className="selectDateHours mr-3">
            {props.id && props.isMobile !== 1 && <FilesExport id={`#${props.id}`} />}
          </div>
        </div>
      }

      <StackBarChart
        yAxisName={props.yAxisName}
        xAxisName={props.xAxisName}
        categoryData={props.categoryData ? props.categoryData : []}
        seriesData={props.seriesData ? props.seriesData : []}
      />
    </SimpleCard>
  );
}

export function MultipleBarChartCard(props) {
  // console.log("props.seriesData", props.seriesData);
  return (
    <SimpleCard className="drilling_dash_block">
      {
        <div className="simple-card-title d-flex justify-content-between">
          <h3 className="text-capitalize mb-1">{props.title}</h3>
          <div className="selectDateHours mr-3">
            {props.isMobile != 1 && <FilesExport id={`#${props.id}`} />}
          </div>
        </div>
      }

      <EchartMultipleBarChart
        customToolTip={props.customToolTip}
        legendFlag={props.legendFlag}
        yAxisName={props.yAxisName}
        xAxisName={props.xAxisName}
        category={props.category ? props.category : []}
        seriesData={
          props.seriesData
            ? props.seriesData
            : [
                // {
                //   color: "#5f6bc2",
                //   name: "Planned Wells",
                //   type: "bar",
                //   barGap: 0,
                //   label: {
                //     normal: {
                //       show: false,
                //       position: "insideBottom",
                //       distance: 5,
                //       align: "left",
                //       verticalAlign: "middle",
                //       rotate: 90,
                //       formatter: "{c}  {name|{a}}",
                //       fontSize: 14,
                //       fontWeight: "bold",
                //       rich: {
                //         name: {
                //           color: "#fff",
                //         },
                //       },
                //     },
                //   },
                //   data: [320, 332, 301, 334, 390, 350, 215],
                // },
              ]
        }
      />
    </SimpleCard>
  );
}
export function BasicBarChartWithLabelCard(props) {
  // console.log("props.seriesData", props.seriesData);
  return (
    <SimpleCard className="drilling_dash_block">
      {
        <div className="simple-card-title d-flex justify-content-between">
          <h3 className="text-capitalize mb-1">{props.title}</h3>
          <div className="selectDateHours mr-3">
            {props.isMobile != 1 && <FilesExport id={`#${props.id}`} />}
          </div>
        </div>
      }

      <BasicBarChartWithLabel
        tooltip={props.customToolTip}
        customeTool={props.customeTool}
        legendFlag={props.legendFlag}
        yAxisName={props.yAxisName}
        xAxisName={props.xAxisName}
        category={props.category ? props.category : []}
        seriesData={
          props.seriesData
            ? props.seriesData
            : [
                // {
                //   color: "#5f6bc2",
                //   name: "Planned Wells",
                //   type: "bar",
                //   barGap: 0,
                //   label: {
                //     normal: {
                //       show: false,
                //       position: "insideBottom",
                //       distance: 5,
                //       align: "left",
                //       verticalAlign: "middle",
                //       rotate: 90,
                //       formatter: "{c}  {name|{a}}",
                //       fontSize: 14,
                //       fontWeight: "bold",
                //       rich: {
                //         name: {
                //           color: "#fff",
                //         },
                //       },
                //     },
                //   },
                //   data: [320, 332, 301, 334, 390, 350, 215],
                // },
              ]
        }
      />
    </SimpleCard>
  );
}
export function BasicBarChartWithLabelAndCustomToolTipCard(props) {
  // console.log("props.seriesData", props.seriesData);
  return (
    <SimpleCard className="drilling_dash_block">
      <div className="simple-card-title d-flex justify-content-between">
        <h3 className="text-capitalize mb-1">{props.title}</h3>
        <div className="selectDateHours mr-3">
          {props.isMobile != 1 && <FilesExport id={`#${props.id}`} />}
        </div>
      </div>

      <BasicBarChartWithLabelAndCustomToolTip
        tooltip={props.customToolTip}
        custumToolTipData={props.custumToolTipData}
        legendFlag={props.legendFlag}
        yAxisName={props.yAxisName}
        xAxisName={props.xAxisName}
        category={props.category ? props.category : []}
        seriesData={
          props.seriesData
            ? props.seriesData
            : [
                // {
                //   color: "#5f6bc2",
                //   name: "Planned Wells",
                //   type: "bar",
                //   barGap: 0,
                //   label: {
                //     normal: {
                //       show: false,
                //       position: "insideBottom",
                //       distance: 5,
                //       align: "left",
                //       verticalAlign: "middle",
                //       rotate: 90,
                //       formatter: "{c}  {name|{a}}",
                //       fontSize: 14,
                //       fontWeight: "bold",
                //       rich: {
                //         name: {
                //           color: "#fff",
                //         },
                //       },
                //     },
                //   },
                //   data: [320, 332, 301, 334, 390, 350, 215],
                // },
              ]
        }
      />
    </SimpleCard>
  );
}
export function FunnelChartCard({ seriesData, title, id, legend, height, isMobile }) {
  return (
    <SimpleCard className="drilling_dash_block">
      {
        <div className="simple-card-title d-flex justify-content-between">
          <h3 className="text-capitalize mb-1">{title}</h3>
          <div className="selectDateHours mr-3">
            {isMobile != 1 && <FilesExport id={`#${id}`} />}
          </div>
        </div>
      }
      <EchartFunnelChart
        seriesData={seriesData ? seriesData : []}
        legend={legend}
        height={height}
      />
    </SimpleCard>
  );
}

export function BodyChartCard({ bodyData, id, title, isMobile }) {
  return (
    <SimpleCard className="drilling_dash_block">
      {
        <div className="simple-card-title d-flex justify-content-between">
          <h3 className="text-capitalize mb-1">{title}</h3>
          <div className="selectDateHours mr-3">
            {isMobile != 1 && <FilesExport id={`#${id}`} isBodyPart />}
          </div>
        </div>
      }
      <BodyPartComponent bodyObj={bodyData} />
    </SimpleCard>
  );
}
